<template>
  <section class="scene-toolbox bg-grey darken-4" :class="{ 'scene-toolbox--open': open }">
    <button class="scene-toolbox__toggle grey darken-4 elavation-4" @click="open = !open">
      <v-icon v-if="!open" color="white">keyboard_arrow_up</v-icon>
      <v-icon v-if="open" color="white">keyboard_arrow_down</v-icon>
    </button>
    <v-card class="scene-toolbox__content">
      <v-tabs
        centered
        dark
        color="grey darken-4"
        slider-color="primary"
        class="fill-height"
      >
        <v-tab ripple>
          Models
        </v-tab>
        <v-tab ripple>
          Lights
        </v-tab>
        <v-tab ripple>
          Text
        </v-tab>
        <v-tab ripple>
          Animation
        </v-tab>

        <v-tab-item class="fill-height" lazy>
          <poly-search v-if="open" />
        </v-tab-item>

        <v-tab-item lazy>
          <lights-menu v-if="open" />
        </v-tab-item>

        <v-tab-item lazy>
          <text-menu v-if="open" />
        </v-tab-item>
        <v-tab-item lazy>
          <toolbox-window v-if="open" title="Animation" icon="movie_filter" />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </section>
</template>

<script>
import PolySearch from '@/components/poly/PolySearch.vue'
import LightsMenu from '@/components/SceneToolbox/LightsMenu/LightsMenu.vue'
import TextMenu from '@/components/SceneToolbox/TextMenu/TextMenu.vue'
import ToolboxWindow from '@/components/SceneToolbox/ToolboxWindow.vue'

export default {
  name: 'SceneToolbox',
  components: {
    PolySearch,
    LightsMenu,
    TextMenu,
    ToolboxWindow
  },
  data () {
    return {
      open: false
    }
  },
  watch: {
    open (open) {
      if (open) {
        this.$emit('open')
      } else {
        this.$emit('closed')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.scene-toolbox {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  transition: transform 0.2s ease;
  z-index: 10;
}

.scene-toolbox--open {
  transform: translate3d(0, -50vh, 0);
}

.scene-toolbox__toggle {
  margin-right: auto;
  margin-left: auto;
  display: block;
  padding: 5px 10px 0px 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  outline: none;
}

.scene-toolbox__content {
  position: absolute;
  width: 100%;
  height: 50vh;
}

/deep/ .v-tabs {
  border-radius: 0px;
}

/deep/ .v-tabs__bar {
  border-radius: 0px;
}

/deep/ .v-window {
  // 48px is height of tab bar
  height: calc(100% - 48px);
}

/deep/ .v-window__container,
/deep/ .v-window-item {
  height: 100%;
}
</style>
